import type { AudienceSegmentEntry } from '@openx/types/gqlTypes.ts';

export function hasNonSellableAudienceSegmentsFromMultipleAccounts(segments: AudienceSegmentEntry[]): boolean {
  const accountIds = new Set(segments.filter(segment => !segment.sellable).map(segment => segment.account_id));
  return accountIds.size > 1;
}
